import { ESRI_MAP } from '@rsos/capstone/src/constants/capabilities';
import { PREMIUM_ESRI_MAP } from '@rsos/constants/permissions';
import { PsapState } from '@rsos/reduxDataStore';
import { SinatraState } from '@rsos/sinatra';

/**
 * Determines if the current user has both `ESRI_MAP` capability and permissions enabled.
 */
const checkEsriMapAccess = (state: {
  psaps: PsapState;
  sinatra: SinatraState;
}) => {
  const isCapabilityEnabled =
    !!state.psaps?.currentPSAP?.activeCapabilities?.[ESRI_MAP];

  const isPermissionEnabled =
    state.sinatra?.user?.currentRole?.permissions?.includes(PREMIUM_ESRI_MAP);

  return isCapabilityEnabled && isPermissionEnabled;
};

export default checkEsriMapAccess;
